"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilPackage = void 0;
const z = __importStar(require("zod"));
const hil_value_variance_js_1 = require("./hil-value-variance.js");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hil_sub_model_metadata_js_1 = require("./hil-sub-model-metadata.js");
const hil_package_metadata_js_1 = require("./hil-package-metadata.js");
const merge_values_js_1 = require("../utils/merge-values.js");
const merge_records_js_1 = require("../utils/merge-records.js");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const hil_package_function_js_1 = require("./hil-package-function.js");
const merge_arrays_js_1 = require("../utils/merge-arrays.js");
const merge_arrays_dto_schema_js_1 = require("../utils/merge-arrays-dto-schema.js");
const merge_records_dto_schema_js_1 = require("../utils/merge-records-dto-schema.js");
const hil_signal_js_1 = require("./hil-signal.js");
const hil_differential_pair_js_1 = require("./hil-differential-pair.js");
const hil_submodel_js_1 = require("./hil-submodel.js");
const hil_implementation_rules_js_1 = require("./hil-implementation-rules.js");
const hilPackageSchema = z.object({
    id: z.string().default(() => (0, cadstrom_shared_1.generateCadstromUid)(cadstrom_shared_1.CadstromObjectType.PackageStorePackage)),
    manufacturerPartNumber: z.string(),
    status: z.nativeEnum(cadstrom_shared_1.PackageStatus).default(cadstrom_shared_1.PackageStatus.Draft),
    datasheetUrl: z.string().nullable().default(null),
    fileId: z.string().nullable().default(null),
    sigmaModelType: z.string().default('ic.generic'),
    signals: hil_signal_js_1.HilSignal.schema.array().default([]),
    differentialPairs: hil_differential_pair_js_1.HilDifferentialPair.schema.array().default([]),
    pinMap: z.record(z.string(), z.string().array()).prefault({}),
    sigmaModelParameters: z.record(z.string(), hil_value_variance_js_1.HilValueVariance.schema).prefault({}),
    absoluteMaximumRatings: z
        .any()
        .array()
        .optional()
        .describe('Deprecated. AMR data is now represented by `boundaries`.'),
    operatingCharacteristics: z
        .any()
        .array()
        .optional()
        .describe('Deprecated. Operating characteristic data is now represented by `boundaries`.'),
    functions: hil_package_function_js_1.HilPackageFunction.schema.array().default([]),
    resources: sigma_engine_shared_1.IComponentResourceSchema.array().default([]),
    modes: sigma_engine_shared_1.ModeBaseSchema.array().default([]),
    boundaries: z
        .custom(() => true)
        .array()
        .default([]),
    spiceModels: hil_submodel_js_1.HilSubModel.schema.array().default([]),
    subModelEditor: hil_sub_model_metadata_js_1.hilSubModelEditorStateSchema.prefault({}),
    metadata: hil_package_metadata_js_1.hilPackageMetadataSchema.prefault({}),
    implementationRules: hil_implementation_rules_js_1.HilImplementationRules.schema.default([]),
    pkgFamilyId: z.string(),
});
const hilPackageDtoSchema = z.object({
    manufacturerPartNumber: z.string().trim().min(1).optional(),
    fileId: z.string().nullable().optional(),
    sigmaModelType: z.string().optional(),
    signals: (0, merge_arrays_dto_schema_js_1.mergeArraysDtoSchema)(z.union([z.string(), z.number()]), hil_signal_js_1.HilSignal.schema, hil_signal_js_1.HilSignal.dtoSchema).optional(),
    differentialPairs: (0, merge_arrays_dto_schema_js_1.mergeArraysDtoSchema)(z.string(), hil_differential_pair_js_1.HilDifferentialPair.schema, hil_differential_pair_js_1.HilDifferentialPair.dtoSchema).optional(),
    pinMap: (0, merge_records_dto_schema_js_1.mergeRecordsDtoSchema)(z.string().array(), z.string().array()).optional(),
    sigmaModelParameters: (0, merge_records_dto_schema_js_1.mergeRecordsDtoSchema)(hil_value_variance_js_1.HilValueVariance.schema, hil_value_variance_js_1.HilValueVariance.dtoSchema).optional(),
    absoluteMaximumRatings: z
        .any()
        .array()
        .optional()
        .describe('Deprecated. AMR data is now represented by `boundaries`.'),
    operatingCharacteristics: z
        .any()
        .array()
        .optional()
        .describe('Deprecated. Operating characteristic data is now represented by `boundaries`.'),
    functions: (0, merge_arrays_dto_schema_js_1.mergeArraysDtoSchema)(z.string(), hil_package_function_js_1.HilPackageFunction.schema, hil_package_function_js_1.HilPackageFunction.dtoSchema).optional(),
    resources: sigma_engine_shared_1.IComponentResourceSchema.array().optional(),
    modes: sigma_engine_shared_1.ModeBaseSchema.array().optional(),
    boundaries: sigma_engine_shared_1.ComponentBoundarySchema.array().optional(),
    spiceModels: hil_submodel_js_1.HilSubModel.schema.array().optional(),
    subModelEditor: hil_sub_model_metadata_js_1.hilSubModelEditorStateSchema.optional(),
    metadata: hil_package_metadata_js_1.hilPackageMetadataSchema.optional(),
    implementationRules: hil_implementation_rules_js_1.HilImplementationRules.dtoSchema
        .nullish()
        .transform((value) => value ?? undefined)
        .optional(),
});
exports.HilPackage = {
    create: (input) => {
        return hilPackageSchema.parse(input);
    },
    merge: async (existing, incoming) => ({
        id: existing.id,
        manufacturerPartNumber: (0, merge_values_js_1.mergeValues)(existing.manufacturerPartNumber, incoming.manufacturerPartNumber),
        status: existing.status,
        datasheetUrl: existing.datasheetUrl,
        fileId: (0, merge_values_js_1.mergeValues)(existing.fileId, incoming.fileId),
        sigmaModelType: (0, merge_values_js_1.mergeValues)(existing.sigmaModelType, incoming.sigmaModelType),
        pinMap: (0, merge_records_js_1.mergeRecords)(existing.pinMap, incoming.pinMap, (merge_values_js_1.mergeValues)),
        sigmaModelParameters: (0, merge_records_js_1.mergeRecords)(existing.sigmaModelParameters, incoming.sigmaModelParameters, hil_value_variance_js_1.HilValueVariance.merge),
        absoluteMaximumRatings: (0, merge_values_js_1.mergeValues)(existing.absoluteMaximumRatings, incoming.absoluteMaximumRatings),
        operatingCharacteristics: (0, merge_values_js_1.mergeValues)(existing.operatingCharacteristics, incoming.operatingCharacteristics),
        functions: (0, merge_arrays_js_1.mergeArrays)(existing.functions, incoming.functions, hil_package_function_js_1.HilPackageFunction.merge),
        resources: (0, merge_values_js_1.mergeValues)(existing.resources, incoming.resources),
        modes: (0, merge_values_js_1.mergeValues)(existing.modes, incoming.modes),
        boundaries: (0, merge_values_js_1.mergeValues)(existing.boundaries, incoming.boundaries),
        spiceModels: (0, merge_values_js_1.mergeValues)(existing.spiceModels, incoming.spiceModels),
        subModelEditor: (0, merge_values_js_1.mergeValues)(existing.subModelEditor, incoming.subModelEditor),
        metadata: { ...existing.metadata, ...incoming.metadata },
        implementationRules: incoming.implementationRules === undefined ?
            existing.implementationRules
            : await hil_implementation_rules_js_1.HilImplementationRules.merge(existing.implementationRules, incoming.implementationRules),
        signals: (0, merge_arrays_js_1.mergeArrays)(existing.signals, incoming.signals, hil_signal_js_1.HilSignal.merge),
        differentialPairs: (0, merge_arrays_js_1.mergeArrays)(existing.differentialPairs, incoming.differentialPairs, hil_differential_pair_js_1.HilDifferentialPair.merge),
        pkgFamilyId: existing.pkgFamilyId,
    }),
    schema: hilPackageSchema,
    dtoSchema: hilPackageDtoSchema,
};
//# sourceMappingURL=hil-package.js.map